import { __awaiter, __generator } from "tslib";
export function sendTransactionalMessage(message, target) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (typeof MessageChannel === 'undefined' || !target) {
                return [2 /*return*/];
            }
            return [2 /*return*/, new Promise(function (resolve) {
                    var messageChannel = new MessageChannel();
                    messageChannel.port1.onmessage = function (messageEvent) {
                        resolve(messageEvent);
                        messageChannel.port1.close();
                        messageChannel.port2.close();
                    };
                    target.postMessage(message, [messageChannel.port2]);
                })];
        });
    });
}
export function sendUnidirectionalMessage(message, target) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            target.postMessage(message);
            return [2 /*return*/];
        });
    });
}
//# sourceMappingURL=SendMessages.js.map